// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as RegionFlag$PrezzeeRibbon from "./RegionFlag.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as RegionIndicator$PrezzeeRibbon from "./RegionIndicator.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";
import * as RegionIndicatorFlag$PrezzeeRibbon from "./RegionIndicatorFlag.bs.js";
import * as FaChevronDown from "@fortawesome/pro-light-svg-icons/faChevronDown";

var border = BsCssJs$PrezzeeRibbon.px(1);

function headerBar(theme) {
  var match = theme.components;
  var regionStrip = match.regionStrip;
  return BsCssJs$PrezzeeRibbon.merge([
              Theme__Typography$PrezzeeRibbon.Styles.smallBody,
              BsCssJs$PrezzeeRibbon.style([
                    BsCssJs$PrezzeeRibbon.backgroundColor(regionStrip.backgroundColor),
                    BsCssJs$PrezzeeRibbon.color(regionStrip.color)
                  ])
            ]);
}

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("flexEnd"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(28))
    ]);

var flagBlock = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.borderWidth(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.borderLeftWidth(border),
      BsCssJs$PrezzeeRibbon.borderRightWidth(border),
      BsCssJs$PrezzeeRibbon.borderStyle("solid"),
      BsCssJs$PrezzeeRibbon.borderColor({
            NAME: "rgba",
            VAL: [
              255,
              255,
              255,
              {
                NAME: "num",
                VAL: 0.2
              }
            ]
          }),
      BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(6)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))
    ]);

var Styles = {
  border: border,
  headerBar: headerBar,
  wrapper: wrapper,
  flagBlock: flagBlock
};

function RegionIndicatorStrip(props) {
  var className = props.className;
  var onChange = props.onChange;
  var onChange$1 = onChange !== undefined ? onChange : (function (param) {
        
      });
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  var icon = JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
        icon: FaChevronDown.faChevronDown,
        className: BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(8))])
      });
  var clickableElem = function (r) {
    var flag = JsxRuntime.jsx(RegionFlag$PrezzeeRibbon.make, {
          src: r.flag,
          size: 18
        });
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(RegionIndicatorFlag$PrezzeeRibbon.make, {
                      flag: flag,
                      icon: Caml_option.some(icon)
                    }),
                className: flagBlock
              });
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(RegionIndicator$PrezzeeRibbon.make, {
                          regions: props.regions,
                          strings: props.strings,
                          selected: props.selected,
                          children: props.children,
                          clickableElem: clickableElem,
                          onChange: onChange$1
                        }),
                    className: Classnames([
                          wrapper,
                          className$1
                        ])
                  }),
              className: headerBar(theme)
            });
}

var make = RegionIndicatorStrip;

export {
  Styles ,
  make ,
}
/* border Not a pure module */
